import abattoir from './images/abattoir-side.png';
import adriana from './images/adriana.png';
import genavieve from './images/genavieve.png';
import glass from './images/glass.png';
import josephine from './images/josephine.png';
import susanna from './images/susanna.png';
import museum from './images/mall_museum_circle_icon.png';
import hazy from './images/final_hazy.jpg';

export const galleryData = [
	{
		title1: 'Art and Digital Media',
		image1: josephine, 
		text1: 'Oil paint study of “The Coronation of Napoleon” by Jacques-Louis David.',
		title2: 'Colored pencil drawing of student in her dorm room.',
		image2: adriana,
		text2: 'Colored pencil drawing of student in her dorm room.',
		title3: 'Mock-up',
		image3: genavieve,
		text3: 'Graphite drawing of woman named Genevieve swimming in western Massachusetts lake.',
		title4: 'Art and Digital Media',
		image4: glass,
		text4: 'Watercolor painting of light refracted through glass.',
		title5: 'Art and Digital Media',
		image5: abattoir,
		text5: 'Pen and ink sketch of building in Western Massachusetts.',
		title6: 'Wireframe',
		image6: susanna,
		text6: 'Oil painting referencing Susanna and the Elders by Artemisia Gentileschi.',
		title7: 'Wireframe',
		image7: museum,
		text7: 'Digital portrait of The Smithsonian National Air and Space Museum’s National Mall location done in Illustrator.',
		title8: 'Wireframe',
		image8: hazy,
		text8: 'Digital portrait of The Smithsonian’s Udvar-Hazy Center in Chantilly Virginia done in Illustrator.',
	},
]